module.exports = __webpack_public_path__ + "static/media/sonder3.7fb9b3c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/sonder3.jpg
// module id = 382
// module chunks = 0